import React from 'react';

const IconMinus = () => (
  <svg width="17" height="17" viewBox="0 -8 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0V1H17V0H0Z" fill="currentColor" />
  </svg>

);

export default IconMinus;
